import { AdminLayout } from "components/admin/admin-layout";
import gql from "graphql-tag";
import { useGetAllPagesQuery } from "lib/graphql-generated";
import Link from "next/link";

const GET_PAGES = gql`
  query GetAllPages {
    pages {
      title
    }
  }
`;

export const AllPages = () => {
  const { data } = useGetAllPagesQuery();

  return (
    <AdminLayout page='Pages'>
      <article>
        <header className='flex flex-col xl:flex-row flex-wrap w-full justify-center space-y-4 xl:space-y-0 xl:space-x-4'>
          <h1 className='header text-4xl ml-auto mr-auto xl:ml-0 xl:mr-auto'>
            Pages
          </h1>
        </header>
        <ul className='mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-4'>
          {data?.pages.map((p) => (
            <li
              key={p.title}
              className='col-span-1 shadow-sm rounded-md bg-white border border-gray-200 overflow-hidden hover:ring-1 ring-green-default cursor-pointer'>
              <Link href={`/admin/pages/${p.title}`}>
                <a className='flex'>
                  <article className='flex flex-row justify-start w-full flex-grow '>
                    <span className='bg-green-default p-4 text-white font-extrabold uppercase'>
                      {p.title.charAt(0)}
                    </span>
                    <h1 className='header my-auto ml-4'>{p.title}</h1>
                  </article>
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </article>
    </AdminLayout>
  );
};

export default AllPages;
